import { Box, Button, Card, CardContent, CardHeader } from '@mui/material';
import FormsyText from 'components/FormsyText/FormsyText';
import 'components/RaisedButton/RaisedButton';
import Formsy from 'formsy-react';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { getI18n } from '../../../../AppReducer';
import { setError } from '../../../App/AppActions';
import LayoutFocused from '../../../App/components/LayoutFocused/LayoutFocused';
import { sendPasswordReminder } from '../../AuthActions';
import { loginMessages } from './components/LoginWidget/LoginWidget';
import styles from './Login.css';

const messages = defineMessages({
  title: {
    id: 'ForgotPassword.Title',
    defaultMessage: 'Password reminder',
  },
  send: {
    id: 'ForgotPassword.Send',
    defaultMessage: 'Send',
  },
  description: {
    id: 'ForgotPassword.Description',
    defaultMessage: 'We will then send you an e-mail with password reset instructions.',
  },
});

function ForgotPasswordPage(props) {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  let emailInput;
  const handleSubmit = async () => {
    try {
      await props.sendPasswordReminder(emailInput.getValue(), props.locale);
      navigate('/forgot-password-sent');
    } catch (e) {
      const msg = e?.bodyJson?.message || e?.message || '';
      if (msg === 'Password reset is managed by your identity provider') {
        props.setError(
          <FormattedMessage
            id="AccountSettings.PasswordManagedByIdP"
            defaultMessage="Your password is managed by your identity provider. Use single sign-on to access your account."
          />,
        );
      } else {
        props.setError(formatMessage('ForgotPassword.UnexpectedError'));
      }
    }
  };
  return (
    <LayoutFocused title={formatMessage(messages.title)} maxWidth="md">
      <Formsy.Form className={styles.form} onValidSubmit={handleSubmit}>
        <Card sx={{ p: 2, m: 4 }}>
          <CardHeader
            title={formatMessage(messages.title)}
            subheader={formatMessage(messages.description)}
          />
          <CardContent sx={{ display: 'flex', flexDirection: 'column' }}>
            <FormsyText
              id="email"
              name="email"
              label={formatMessage(loginMessages.email)}
              placeholder={formatMessage(loginMessages.emailPlaceholder)}
              required
              autoFocus
              fullWidth
              variant="outlined"
              size="small"
              validations="isEmail"
              ref={el => {
                emailInput = el;
              }}
              validationError={formatMessage(loginMessages.invalidEmail)}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Button type="submit" variant="contained" color="primary" sx={{ width: '100%', mt: 2 }}>
              {formatMessage(messages.send)}
            </Button>
          </CardContent>
        </Card>
        <Box component={Link} to="/login" sx={{ mt: 4, alignSelf: 'center' }}>
          <FormattedMessage
            id="ForgotPassword.GoBackToLogin"
            defaultMessage="Go back to login page"
          />
        </Box>
      </Formsy.Form>
    </LayoutFocused>
  );
}

ForgotPasswordPage.propTypes = {
  sendPasswordReminder: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  locale: getI18n(state).locale,
});

const mapDispatchToProps = dispatch => ({
  sendPasswordReminder(email, locale) {
    return dispatch(sendPasswordReminder(email, locale));
  },
  setError(msg) {
    dispatch(setError(msg));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ForgotPasswordPage));
